'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEND_TYPING_MESSAGE_DEBOUNCE_MS = exports.SEND_TYPING_MESSAGE_DEBOUNCE_MS = 5000;


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/constants/typingIndicatorConstants.js
// module id = 1169
// module chunks = 2 3